import { Component, DoCheck, ElementRef, HostListener, inject, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NavbarTxtsKey } from 'src/app/interfaces/texts/navbar-txt-key.interface';
import { TextsDataService } from 'src/app/services/texts-data.service';
import { HomeComponent } from '../../pages/home/home.component';
import { AuthService } from 'src/app/core/auth/auth.service';
import { map, Observable } from 'rxjs';
import { SessionStorageDataService } from 'src/app/services/session-storage-data.service';
import { CiudUserAuthData } from 'src/app/core/auth/authData.model';
import { ApiResponse } from '../chat-layout-assistance/interface/response-agent-API.interface';
import { ImagesData } from 'src/app/interfaces/images/image.data.interface';
import { env } from 'src/environments/environments';
//import { AuthGoogleService } from 'src/app/core/auth/auth-google.service';


@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, DoCheck {
    @Input() logoGov?: string;
    texts?: NavbarTxtsKey;
    url_perfilUsuario: string = '';

    isAuthenticated$: Observable<boolean>;

    currentUser: CiudUserAuthData | null = null;
    userData?: CiudUserAuthData;
    imgUserName: string = '';
    isDropdownOpen = false;

    navbarClass: string = '';





    @ViewChild('dropdownMenu', { static: false }) dropdownMenu: ElementRef | undefined;

    constructor(
        public router: Router,
        private textsDataService: TextsDataService,
        public authService: AuthService,
        private sessionStorageDataService: SessionStorageDataService,
    ) {
        this.isAuthenticated$ = this.authService.ciudUser$.pipe(
            map(user => !!user)
        );
    }

    ngOnInit(): void {
        this.url_perfilUsuario = `${env.URL_PERFIL_USUSARIO}`;

        this.textsDataService.getTextData().subscribe(data => {
            if (data) {
                this.texts = data.navbar;
            }
        });

        if (this.authService.isLoggedIn()) {
            this.authService.startSessionCheck();
        }

        this.userData = this.sessionStorageDataService.getData('user');
        this.isAuthenticated$.subscribe(isAuthenticated => {
            this.navbarClass = isAuthenticated ? 'bg-CyanBlue text-white border-CyanBlue' : 'bg-white text-black border-[#ffffff]';
        });
    }

    ngDoCheck() {
        this.currentUser = this.authService.getCurrentUser();
        if (this.currentUser?.nombres && this.currentUser?.apellidos) {
            // Usuario existe, usar primer nombre y primer apellido
            let primerNombre = this.currentUser.nombres.split(' ')[0];
            let primerApellido = this.currentUser.apellidos.split(' ')[0];
            this.imgUserName = `https://eu.ui-avatars.com/api/?name=${primerNombre}+${primerApellido}&size=1000&background=bbdac8`;
        } else {
            // No hay usuario o faltan datos, usar 'NN'
            this.imgUserName = `https://eu.ui-avatars.com/api/?name=NN&size=1000&background=bbdac8`;
  }

    }


    // Maneja el clic fuera del dropdown
    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        const clickedInside = (event.target as HTMLElement).closest('.relative');

        if (this.dropdownMenu && !this.dropdownMenu.nativeElement.contains(event.target)) {
            this.isDropdownOpen = false;
        }
    }

    // Función para manejar clic dentro del dropdown
    handleClickInside(event: Event) {
        event.stopPropagation();
    }

    // Función para cerrar sesión
    logout() {
        this.isDropdownOpen = false;

        setTimeout(() => {
            this.authService.logout();
        }, 100);
    }

    // Alterna la visibilidad del dropdown
    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }


    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    sidebarClassApplied = false;
    sidebarToggleClass() {
        this.sidebarClassApplied = !this.sidebarClassApplied;
    }

    // Navbar Sticky
    isSticky: boolean = false;
    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        this.isSticky = scrollPosition >= 50;
        this.setActiveSection(scrollPosition);
    }

    activeSection: string = '';

    setActiveSection(scrollPosition: number) {
        const sections = document.querySelectorAll('section');
        let currentSection = '';

        sections.forEach((section: any) => {
            const sectionTop = section.offsetTop - 100;
            if (scrollPosition >= sectionTop) {
            currentSection = section.getAttribute('id');
            }
        });

        this.activeSection = currentSection;
    }


}
